<div class="modal-header" [ngClass]="{'bg-danger error-header ': hasError,'warning-text':hasWarning}">
    <div class="error-text" *ngIf="hasError">
        Error
    </div>
	<div  *ngIf="hasWarning">
       <h4>Warning</h4>
    </div>
	<h4 *ngIf="!hasError && !hasWarning">
        {{ title }}
    </h4>
	<button type="button" class="close" aria-label="Close" (click)="close()" *ngIf="showClose">
		<span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
	<p class="message-container" [innerHTML]="data"></p>
</div>
<div class="modal-footer">
    <ng-container *ngIf="!swapButtonOrder">
        <button mat-raised-button type="button" [color]="swapPrimaryButton ? 'btnprimary' : 'btnwhite'" (click)="close(true)" *ngIf="showCancel" class="mr-4">
            {{ labelCancelButton }}
        </button>
        <button mat-raised-button type="button" [color]="swapPrimaryButton ? 'btnwhite' : 'btnprimary'" (click)="close()" *ngIf="showClose">
            {{ labelButton }}
        </button>
    </ng-container>
    <ng-container *ngIf="swapButtonOrder">
        <button mat-raised-button type="button" color="btnprimary" (click)="close()" *ngIf="showClose" class="mr-4">
            {{ labelButton }}
        </button>
        <button mat-raised-button type="button" color="btnwhite" (click)="close(true)" *ngIf="showCancel">
            {{ labelCancelButton }}
        </button>
    </ng-container>
</div>
